import React from "react";
import { TableCell, TableRow, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { VALUE_FONT_WEIGHT } from "../../Constants";
import WalletIcon from "../layout/WalletIcon";
import { selectWalletById } from "../../store/walletSlice";
import { selectCurrencies } from "../../store/currencySlice";

/**
 * For SET_BALANCE (Change balance) transactions.
 */
const ChangeBalance = ({ transaction, onClick }) => {
    const description = transaction.description || "Change balance";
    const rawValue = transaction.valueFrom ?? transaction.valueTo ?? transaction.value;
    const walletId = transaction.walletFrom ?? transaction.walletTo ?? transaction.wallet;
    const wallet = useSelector((state) => selectWalletById(state, walletId));
    const currencies = useSelector(selectCurrencies) || [];
    const currency = wallet?.currency != null
        ? currencies.find((c) => c.id === wallet.currency || c.id == wallet.currency)
        : null;
    const baseValue = rawValue != null ? String(rawValue) : "—";
    const displayValue = currency?.shortName ? `${baseValue} ${currency.shortName}` : baseValue;
    const valueColor = "text.secondary";

    const isDraft = transaction?.state === "DRAFT";

    return (
        <TableRow
            key={transaction.id}
            className={isDraft ? "Draft" : undefined}
            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            onClick={(event) => onClick(transaction)}
        >
            <TableCell padding="none" align="center" sx={{ width: 56 }}>
                {wallet && <WalletIcon image={wallet.image} sx={{ fontSize: 28 }} />}
            </TableCell>
            <TableCell component="th" scope="row">
                <Typography variant="body1">{description}</Typography>
                <Typography variant="body2" color="text.secondary">{wallet?.name || "—"}</Typography>
            </TableCell>
            <TableCell align="right">
                <Typography variant="body1" sx={{ color: valueColor, fontWeight: VALUE_FONT_WEIGHT }}>
                    {displayValue}
                </Typography>
            </TableCell>
        </TableRow>
    );
};

ChangeBalance.propTypes = {
    transaction: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        description: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        walletFrom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }).isRequired,
    onClick: PropTypes.func.isRequired,
};

export default ChangeBalance;
